import Joi from '@hapi/joi'

export const DailyPluckingAverageAnalysisRegisteredSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().label("Estate").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().label("Division").messages({
        "any.invalid": `Please select valid Division`,
        "any.required": `Division required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month required`
    })
}